import React, { useRef, useCallback } from 'react';
import cx from 'classnames';

function useShadowLine({ className } = {}) {
  const shadowLineRef = useRef();

  const onScroll = useCallback(({ target }) => {
    shadowLineRef.current.classList[target.scrollTop > 0 ? 'add' : 'remove']('active');
  }, []);

  return [<div ref={shadowLineRef} className={cx('shadow-line', className)} />, onScroll];
}

export default useShadowLine;
